import UserIcon from "assets/icons/User";
import IconLabel from "./IconLabel";

const UserLabel = ({ icon, ...props }) => (
  <IconLabel icon={icon ?? <UserIcon />} {...props} />
);

export default UserLabel;
